import { render, staticRenderFns } from "./AdminSettingCategoriesPopup.vue?vue&type=template&id=4aae952c&scoped=true&"
import script from "./AdminSettingCategoriesPopup.vue?vue&type=script&lang=js&"
export * from "./AdminSettingCategoriesPopup.vue?vue&type=script&lang=js&"
import style0 from "./AdminSettingCategoriesPopup.vue?vue&type=style&index=0&id=4aae952c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aae952c",
  null
  
)

export default component.exports